import { CSSProperties, type PropsWithChildren } from 'react';
import { tv } from '../_lib/utils';
import { styles as textStyles, styleTypes } from '../Text';

const styles = tv({
	slots: {
		base: "font-poppins text-body-lg [&>*+*]:mt-6 [&>:first-child]:mt-0 [&>h1]:text-heading-md [&>h2]:text-heading-sm [&>h3]:text-heading-2xs [&>h4]:text-heading-3xs [&>h5]:text-heading-4xs [&>h6]:text-heading-5xs [&_ul]:pl-8 [&_ul_ul]:mt-2 [&_ul_li]:mb-[0.5em] [&_ul_li]:list-disc [&_ol]:pl-8 [&_ol_ol]:mt-2 [&_ol_ol]:pl-[3.25rem] [&_ol_li]:mb-[0.5em] [&_ol]:[counter-reset:ordered-list] [&_ol_li]:[counter-increment:ordered-list] [&_ol_li]:relative [&_ol_li]:before:content-[counters(ordered-list,'.')] [&_ol_li]:before:font-poppins [&_ol_li]:before:font-bold [&_ol_li]:before:text-body-lg [&_ol_li]:before:absolute [&_ol_li]:before:right-[100%] [&_ol_li]:before:pr-2 [&_p]:break-words [&_a]:text-text-brand [&_a]:underline [&_a]:decoration-dashed [&_a]:decoration-1 [&_a]:underline-offset-4 [&_a:hover]:no-underline [&_blockquote]:pl-spacing-xs [&_blockquote]:border-l-2 [&_blockquote]:border-border-primary [&_blockquote]:open-quote  [&_blockquote]:close-quote",
	},
	variants: {
		type: {
			default: {
				base: 'font-sans text-body-lg',
			},
			...textStyles.variants.type,
		},
	},
});

export type TypographyProps = {
	as?: string;
	className?: string;
	styleType?: 'default' | (typeof styleTypes)[number];
	style?: CSSProperties;
};

export function Typography({ as: El = 'div', styleType = 'default', className, ...props }: PropsWithChildren<TypographyProps>) {
	const { base } = styles({ type: styleType });

	return (
		// @ts-expect-error
		<El {...props} className={`[&>h1]:text-text-primary [&>h2]:text-text-primary ${base()} ${className || ''}`}>
			{props.children}
		</El>
	);
}
